import React from 'react'

export default function VisiGiftCallHistory() {
  return (
    <div>VisiGiftCallHistory</div>
  )
}
